// Provider do runtime por aba (separado dos hooks para o fast-refresh não reclamar de mistura
// componente + funções). Consumido pelo TabKeepAliveHost.
import { TabRuntimeContext } from "./tabRuntime";

export function TabRuntimeProvider({
  tabKey,
  active,
  children,
}: {
  tabKey: string;
  active: boolean;
  children: React.ReactNode;
}) {
  return <TabRuntimeContext.Provider value={{ tabKey, active }}>{children}</TabRuntimeContext.Provider>;
}
